import { render, staticRenderFns } from "./add-interview-quiz.html?vue&type=template&id=fbb42474&scoped=true&"
import script from "./add-interview-quiz.js?vue&type=script&lang=js&"
export * from "./add-interview-quiz.js?vue&type=script&lang=js&"
import style0 from "./add-interview-quiz.scss?vue&type=style&index=0&id=fbb42474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb42474",
  null
  
)

export default component.exports